__turbopack_context__.v({
  "formBody": "_3vXZna_formBody",
  "formColumn": "_3vXZna_formColumn",
  "formFooter": "_3vXZna_formFooter",
  "formHeader": "_3vXZna_formHeader",
  "layout": "_3vXZna_layout",
  "pressable": "_3vXZna_pressable",
  "quoteBlock": "_3vXZna_quoteBlock",
  "terraceColumn": "_3vXZna_terraceColumn",
  "terraceImage": "_3vXZna_terraceImage",
  "terraceVignette": "_3vXZna_terraceVignette",
});
